import { BehaviorSubject, Observable } from 'rxjs';

export interface EditableConfigGridData {
	isDirty?: boolean;
	saving?: boolean;
	doSave?: boolean;
	metadata?: any;
}

export abstract class EditableGridService {

	protected entity: string;

	private formDataSubject = new BehaviorSubject({});
	private formDataListener = this.formDataSubject.asObservable();

	/**
	 * Set entity type
	 * @param entity
	 */
	setEntity(entity: string): void {
		this.entity = entity;
	}

	/**
	 * Sets the util metadata to communicate with other components like breadcrumbr header comp.
	 * @param data
	 */
	setFormData(data: EditableConfigGridData): void {
		this.formDataSubject.next(data);
	}

	/**
	 * Returns Saving Rule listener observable.
	 */
	getFormDataListener(): Observable<any> {
		return this.formDataListener;
	}

}
